<template>
  <div class="iodine_test">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
      class="mr-5"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="cyan darken-1" dark >
          <template v-if="fab">
            <v-icon>
              mdi-menu-up
            </v-icon>
          </template>
          <template v-else>
            <v-icon>
              mdi-menu-down
            </v-icon>
          </template>
            {{ $t("experiment.fab.reference") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="indigo" @click="openLabManualDialog();getLabManual()">
          <v-icon>mdi-file-document</v-icon>
          {{ $t("experiment.fab.lab_manual") }}
        </v-btn>
      </template>
      <template>
        <v-btn  dark color="green"  @click="openSetupDialog(); getSetupPhoto()">
          <v-icon> mdi-image-search </v-icon>
          {{ $t("experiment.fab.setup_photo") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="amber darken-3" @click="openVideoDemoDialog();getExperimentVideoDemo()">
          <v-icon>mdi-play-circle</v-icon>
          {{ $t("experiment.fab.video_demo") }}
        </v-btn>
      </template>
    </v-speed-dial>
    <v-row>
      <v-col xs="12" sm="5">
        <v-card>
          <v-card-text>
            <div>{{ $t('experiment.camera.camera_1_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_1)">
              <rotatable-camera :url="api.camera_1.url" :rotation="Number(api.camera_1.rotate) || 0" />
            </div>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div>{{ $t('experiment.camera.camera_2_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_2)">
              <rotatable-camera :url="api.camera_2.url" :rotation="Number(api.camera_2.rotate) || 0" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="7">
        <v-expansion-panels v-model="controlPanel">
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>{{ $t("experiment.panel.control_header") }}</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="pb-3">
                <v-card-text>
                  <v-row>
                    <v-col class="py-2" xs="12" sm="12">
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <h5>{{ $t("experiment.panel.control.iodine_test.test_tube.label") }}</h5>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="4">
                          <table>
                            <tr class="subtitle-1">
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.iodine_test.test_tube.washed_label") }}</td>
                              <td><b>{{ experiment_status.wash_status }}</b>{{ $t("experiment.panel.control.iodine_test.test_tube.washed_unit") }}</td>
                            </tr>
                            <tr>
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.iodine_test.test_tube.wash_max_label") }}</td>
                              <td>{{ max_count.max_water }}{{ $t("experiment.panel.control.iodine_test.test_tube.wash_max_unit") }}</td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="8">
                          <p class="my-0" style="vertical-align: top;">{{ $t("experiment.panel.control.iodine_test.test_tube.action_label") }}</p>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined
                            :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                              ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false)"
                            @click="clientAction('setCommand', 'device_1', 'SHAKE' + '|0')">
                            {{ $t("experiment.panel.control.iodine_test.test_tube.shake_btn") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.wash_status >= max_count.max_water)"
                            @click="promptWash()">
                            {{ $t("experiment.panel.control.iodine_test.test_tube.wash_btn") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <hr class="mt-2 mb-1">
                    </v-col>
                    <v-col class="py-2" xs="12" sm="12">
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <h5 v-if="$i18n.locale=='tc'">{{ label.sol1["chi"] }}</h5>
                          <h5 v-else>{{ label.sol1["eng"] }}</h5>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="4">
                          <table>
                            <tr class="subtitle-1">
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol1.added_label") }}</td>
                              <td><b>{{ experiment_status.sol1_status }}</b>{{ $t("experiment.panel.control.titration.sol1.added_unit") }}</td>
                            </tr>
                            <tr>
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol1.add_max_label") }}</td>
                              <td>{{ max_count.max_sol1 }}{{ $t("experiment.panel.control.titration.sol1.add_max_unit") }}</td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="8">
                          <p v-if="$i18n.locale=='tc'" class="my-0" style="vertical-align: top;">添加{{ label.sol1["chi"] }}</p>
                          <p v-else class="my-0" style="vertical-align: top;">Add {{ $t("experiment.panel.control.titration.sol1.action_label") }}</p>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol1_status >= max_count.max_sol1)"
                            @click="clientAction('setCommand', 'device_1', 'SOL1' + '|3')">
                            {{ $t("experiment.panel.control.titration.add_btn.large_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.large_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol1_status >= max_count.max_sol1)"
                            @click="clientAction('setCommand', 'device_1', 'SOL1' + '|2')">
                            {{ $t("experiment.panel.control.titration.add_btn.medium_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.medium_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol1_status >= max_count.max_sol1)"
                            @click="clientAction('setCommand', 'device_1', 'SOL1' + '|1')">
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.small_btn_unit") }}
                            <br>
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_label") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <hr class="mt-2 mb-1">
                    </v-col>
                    <v-col class="py-2" xs="12" sm="12">
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <h5 v-if="$i18n.locale=='tc'">{{ label.sol2["chi"] }}</h5>
                          <h5 v-else>{{ label.sol2["eng"] }}</h5>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="4">
                          <table>
                            <tr class="subtitle-1">
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol2.added_label") }}</td>
                              <td><b>{{ experiment_status.sol2_status }}</b>{{ $t("experiment.panel.control.titration.sol2.added_unit") }}</td>
                            </tr>
                            <tr>
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol2.add_max_label") }}</td>
                              <td>{{ max_count.max_sol2 }}{{ $t("experiment.panel.control.titration.sol2.add_max_unit") }}</td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="8">
                          <p v-if="$i18n.locale=='tc'" class="mb-0" style="vertical-align: top;">添加{{ label.sol2["chi"] }}</p>
                          <p v-else class="mb-0" style="vertical-align: top;">Add {{ label.sol2["eng"] }}</p>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol2_status >= max_count.max_sol2)"
                            @click="clientAction('setCommand', 'device_1', 'SOL2' + '|3')">
                            {{ $t("experiment.panel.control.titration.add_btn.large_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.large_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol2_status >= max_count.max_sol2)"
                            @click="clientAction('setCommand', 'device_1', 'SOL2' + '|2')">
                            {{ $t("experiment.panel.control.titration.add_btn.medium_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.medium_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol2_status >= max_count.max_sol2)"
                            @click="clientAction('setCommand', 'device_1', 'SOL2' + '|1')">
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.small_btn_unit") }}
                            <br>
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_label") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <hr class="mt-2 mb-1">
                    </v-col>
                    <v-col class="py-2" xs="12" sm="12">
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <h5 v-if="$i18n.locale=='tc'">{{ label.sol3["chi"] }}</h5>
                          <h5 v-else>{{ label.sol3["eng"] }}</h5>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="4">
                          <table>
                            <tr class="subtitle-1">
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol3.added_label") }}</td>
                              <td><b>{{ experiment_status.sol3_status }}</b>{{ $t("experiment.panel.control.titration.sol3.added_unit") }}</td>
                            </tr>
                            <tr>
                              <td class="pr-2" style="vertical-align: top;">{{ $t("experiment.panel.control.titration.sol3.add_max_label") }}</td>
                              <td>{{ max_count.max_sol3 }}{{ $t("experiment.panel.control.titration.sol3.add_max_unit") }}</td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col class="py-0" xs="12" sm="8">
                          <p v-if="$i18n.locale=='tc'" class="mb-0" style="vertical-align: top;"> 添加{{ label.sol3["chi"] }}</p>
                          <p v-else class="mb-0" style="vertical-align: top;">Add {{ label.sol3["eng"] }}</p>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol3_status >= max_count.max_sol3)"
                            @click="clientAction('setCommand', 'device_1', 'SOL3' + '|3')">
                            {{ $t("experiment.panel.control.titration.add_btn.large_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.large_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol3_status >= max_count.max_sol3)"
                            @click="clientAction('setCommand', 'device_1', 'SOL3' + '|2')">
                            {{ $t("experiment.panel.control.titration.add_btn.medium_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.medium_btn_unit") }}
                          </v-btn>
                          <v-btn class="mx-2 mt-1 mb-2 chem-btn" color="primary" outlined :disabled="(((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role') != 'player' && controlAuth == false) ||
                            ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role') == 'player' && controlAuth == false) ||
                            (experiment_status.sol3_status >= max_count.max_sol3)"
                            @click="clientAction('setCommand', 'device_1', 'SOL3' + '|1')">
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_ml") }}{{ $t("experiment.panel.control.titration.add_btn.small_btn_unit") }}
                            <br>
                            {{ $t("experiment.panel.control.titration.add_btn.small_btn_label") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-overlay absolute :value="loop_flag">
                    <v-btn color="primary">
                      Operating
                      <v-progress-circular indeterminate size="12" class="ma-4"></v-progress-circular>
                    </v-btn>
                  </v-overlay>
                  <v-overlay absolute :value="loading">
                    <v-btn color="primary">
                      Measuring

                      <v-progress-circular indeterminate size="12" class="ma-4"></v-progress-circular>
                    </v-btn>
                  </v-overlay>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-dialog v-model="confirmWashDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ $t("experiment.panel.control.iodine_test.test_tube.prompt_wash_header") }}
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-4" type="error">
              {{ $t("experiment.panel.control.iodine_test.test_tube.prompt_wash_alert") }}
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="confirmWash">{{ $t("experiment.panel.control.iodine_test.test_tube.prompt_wash_confirm_btn") }}</v-btn>
          <v-btn color="primary" text @click="cancelWash">{{ $t("experiment.panel.control.iodine_test.test_tube.prompt_wash_cancel_btn") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.setup_photo.header") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_video_demo" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeVideoDemoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.video_demo.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="video_demo.school_chi.path!=null || video_demo.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_en.path" target="_BLANK">{{ video_demo.school_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_chi.path" target="_BLANK">{{ video_demo.school_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="video_demo.school_chi.path==null && video_demo.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_en.path" target="_BLANK">{{ video_demo.suggested_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_chi.path" target="_BLANK">{{ video_demo.suggested_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_camera" max-width="1000" >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeCameraDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.camera.dialog_header") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-3">
          <rotatable-camera :url="dialog_camera_src.url" :rotation="Number(dialog_camera_src.rotate) || 0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import RotatableCamera from "@/components/RotatableCamera.vue";
import ExperimentBasic from "@/services/dds/api_basic_experiment";
export default {
  name: "iodine_test",
  components: {
    ExperimentTitle,
    RotatableCamera,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      dialog_camera: false,
      dialog_camera_src: {},
      label: {
        sol1: {"eng": "Solution 1","chi": "溶液 1"},
        sol2: {"eng": "Solution 2","chi": "溶液 2"},
        sol3: {"eng": "Solution 3","chi": "溶液 3"},
      },
      experiment_status: {
        wash_status: 0,
        sol1_status: 0,
        sol2_status: 0,
        sol3_status: 0,
      },
      max_count: {
        max_water: 8,
        max_sol1: 4,
        max_sol2: 4,
        max_sol3: 4,
      },
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      dialog_lab_manual: false,
      dialog_video_demo: false,
      confirmWashDialog: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_code: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: 0,
      controlPanel2: 0,
      realTimePanel: 0,
      camera1_url: null,
      camera2_url: null,
      stored_data: [["Time", "Set 1 Temperature", "Set 2 Temperature"]],
      source_status: 0,
      atte_status: 0,
      loading: false,
      loop_flag: false,
      setup_photos: [],
      lab_manual:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      video_demo:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_1: "",
        camera_2: "",
      },
    };
  },
  mounted: function () {
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_code = self.$store.state.user.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_code = self.$route.params.school_code;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getValue("camera_1", function () {
      self.api.camera_1 = self.api.value;
      self.getValue("camera_2", function () {
        self.api.camera_2 = self.api.value;
        self.getValue("device_1", function () {
          self.experiment_status.wash_status = self.api.value.wash_state;
          self.experiment_status.sol1_status = self.api.value.sol1_state;
          self.experiment_status.sol2_status = self.api.value.sol2_state;
          self.experiment_status.sol3_status = self.api.value.sol3_state;
        });
      });
    });
    self.checkOverrided();
    setInterval(function () {
      //loop distance value
      if (self.loop_flag) {
        self.getValue("device_1", function () {
          if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
            self.experiment_status.wash_status = self.api.value.wash_state;
            self.experiment_status.sol1_status = self.api.value.sol1_state;
            self.experiment_status.sol2_status = self.api.value.sol2_state;
            self.experiment_status.sol3_status = self.api.value.sol3_state;
          }
        });
      }
    }, 1000);
    self.experiment_name = "IODINE_TEST";
    self.getSolutionConfig();
  },
  methods: {
    popCamera(camera) {
      var self = this;
      self.dialog_camera_src = camera;
      self.dialog_camera = true;
    },
    openCameraDialog(){
      var self = this;
      self.dialog_camera = true;
    },
    closeCameraDialog(){
      var self = this;
      self.dialog_camera = false;
      self.dialog_camera_src = {};
    },
    openLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = true;
    },
    closeLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = false;
    },
    openVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = true;
    },
    closeVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = false;
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    promptWash(){
      var self = this;
      self.confirmWashDialog = true;
    },
    confirmWash(){
      var self = this;
      self.clientAction('setCommand', 'device_1', 'FLUSH' + '|0');
      self.confirmWashDialog = false;
    },
    cancelWash(){
      var self = this;
      self.confirmWashDialog = false;
    },
    changeCheck() {
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
  },
  beforeDestroy() {
    if (this.$refs.camera1Image) {
      this.$refs.camera1Image.src = '';
    }
    if (this.$refs.camera2Image) {
      this.$refs.camera2Image.src = '';
    }
    if (this.$refs.cameraImagePop) {
      this.$refs.cameraImagePop.src = '';
    }
  },
};
</script>
<style>
/* This is for documentation purposes and will not be needed in your application */
.v-speed-dial {
  position: absolute;
  z-index: 2;
}

.v-btn--floating {
  position: relative;
  z-index: 5;
}

.control-content>.v-expansion-panel-content__wrap {
  padding: 0;
}
.chem-btn {
  text-transform: none;
}
</style>
